import { Component, Output, EventEmitter, OnInit, AfterViewInit, DoCheck, ViewChild, ElementRef, Inject, OnDestroy } from '@angular/core';
import { ArticleService } from './article.service';
import { NavService } from '../header/nav/nav.service';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BreadcrumbService } from '../header/breadcrumb/breadcrumb.service';
import { SharedService} from '../common/shared.service';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/switchMap';
import { ISubscription } from 'rxjs/Subscription';
import { TopnavService } from '../header/topnav/topnav.service';
import { SafeHtmlPipe } from '../pipe/safe-html.pipe';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import 'fullcalendar';
import * as moment from 'moment-timezone';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for Content Category - category/:id
 **/
@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css'],
  providers: [ SafeHtmlPipe]
})
export class ArticleComponent implements OnInit, AfterViewInit, OnDestroy, DoCheck {
  @ViewChild('scrollpanel', { read: ElementRef }) public scrollpanel: ElementRef;
  statusID: any;
  langIdVal: string;
  subID: number;
  moduleName: string;
  public loading = false;
  public showLeftRightButton = false;
  @ViewChild('textarea') textarea: ElementRef;
  @Output() menuClick = new EventEmitter();

  lang: any;
  langId: any;

  breadcrumb: any;
  isValid: any;
  topicID: number;
  public selectedIndex: number = 4;
  articles: any[];

  articleData: any;
  @Output() langChange = new EventEmitter();

  //private subscription: ISubscription;
  private subscriptionLang: ISubscription;
  public subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionFontSize: ISubscription;
  private subsriptionArticle : ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };
  public menuLink = '';
  private imageNode: any;
  public showImageBox: string='none';
  activityData : any; 
  event: any = [];
  options: Object;
  mediaUrl: any = this.config.externalMediaURL +'/images/';
  public currEPartCatCode: number = 0;
  public currArchCatCode: number = 0;
  public ePartCatList: any = [];
  public ePartArchList: any = [];
  public selected: number = 0;
  public selectedArch: number = 0;
  public selectedActList: any;
  public selectedArchList: any;
  public myflag: any;
  private currentSelected: number = 0;
  private chgSelected: number = 0;

  private articleLoaded: boolean = false;


  constructor(private datePipe:DatePipe, private imageRef: ElementRef, private activatedRoute: ActivatedRoute, private sharedService: SharedService, public safeHTML:SafeHtmlPipe, private http:HttpClient, public articleService: ArticleService, private topnavservice: TopnavService, private route: ActivatedRoute, private navService: NavService, private translate: TranslateService, private router: Router, private breadcrumbService: BreadcrumbService, @Inject(APP_CONFIG) public config: AppConfig) {

    this.lang = translate.currentLang;
   
    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
      console.log('category: onLangChange');
      const myLang = translate.currentLang;

      if (myLang == 'en') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.langId = 1;
          this.moduleName = this.router.url.split('/')[1];
          this.topicID = parseInt(this.router.url.split('/')[2]);
          // this.navService.triggerArticle(this.moduleName, this.langId, this.topicID);
        });

      }
      if (myLang == 'ms') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.langId = 2;
          this.moduleName = this.router.url.split('/')[1];
          this.topicID = parseInt(this.router.url.split('/')[2]);
          this.subID = parseInt(this.router.url.split('/')[3]);
          // this.navService.triggerArticle(this.moduleName,  this.langId, this.topicID);
        });
      }

      if (this.topnavservice.flagLang) {
         if (!this.articleLoaded) {
           console.log('return if article not yet loaded');
           return;
         }
        //if (this.moduleName == 'category') {
          this.navService.triggerArticle(this.moduleName, this.langId, this.topicID);
          if (this.topicID == 658) {
            this.chgSelected = this.currentSelected;  
            this.selected=0;
            //this.getEpartCategoryList(this.langId)
          }
        //}
        /*if (this.moduleName == 'subcategory') {
          this.navService.triggerSubArticle(this.subID, this.langId,'noaudit');
        } else if (this.moduleName == 'content') {
          this.navService.triggerContent(this.subID, this.langId,'noaudit');
        } else {
          this.navService.triggerArticle(this.moduleName, this.langId, this.topicID, 'noaudit');
          if (this.topicID == 658) {
            this.chgSelected = this.currentSelected;  
            this.selected=0;
            this.getEpartCategoryList(this.langId)
          }
          
        } */
       
      }

    });

    route.params.subscribe(val => {
      if (this.moduleName == 'category') {
        //this.navService.triggerArticle(this.moduleName, this.langId, this.topicID);
        this.ngAfterViewInit();
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
        this.translate.setDefaultLang('ms');
        this.translate.use('ms');
      } else {
        this.myflag = null;
      } 
    });
  
    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      $('.mat-tab-label').css('font-size', this.fontSize.sizeS);
      $('.mat-tab-link').css('font-size',  this.fontSize.sizeS);

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100); 

      setTimeout(()=> {
        $('.fc-center h2').css('font-size', this.fontSize.sizeL);
        $('.fc-day-number').css('font-size', this.fontSize.sizeS);
        $('.fc-button').css('font-size', this.fontSize.sizeS);
        $('.fc-day-header').css('font-size', this.fontSize.sizeS);
        $('.fc-content').css('font-size', this.fontSize.sizeS);
      }, 1000);

    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data) => {
      this.fontType = data;
    
        $('.mat-tab-label').css('font-family', this.fontType);
        $('.mat-tab-link').css('font-family', this.fontType);
    
    });
    
    this.subsriptionArticle = this.articleService.articleUpdated.subscribe((status) => {
     
        if (translate.currentLang == 'en') {
          this.langId = 1;
        } else {
          this.langId = 2;    
        }
        this.getEpartCategoryList(this.langId);

        this.generateCalendar();
        this.catSelectedChange();
        this.catSelectedArchChange(); 
      
    });

  }

  selectedIndexChange(val :number ){
    this.currentSelected=val;
  }

  generateCalendar() {
    let activityData = this.articleService.articles.filter((article) => {
      return article.contentList[0];
    });

    if (activityData[0] && activityData[0].contentList) {
      //console.log(activityData[0].contentList);
      let calendarData = activityData[0].contentList.filter((list) => {
        return list.tab == 'Kalendar Aktiviti' || list.tab == 'Calendar Activity';
      });

      if (calendarData[0] && calendarData[0].contents) {
        console.log(this.activityData);
        this.activityData = calendarData[0].contents;
        this.setCalendarEvents(this.activityData);
        this.renderCalendar(this.event, this.mediaUrl);
        //alert('masuk');
       
      }
    }

  }

  getTabText(tabText) {
    if (tabText == 'Kalendar Aktiviti') {
      return "Senarai E-Penyertaan";
    } else if (tabText == 'Calendar Activity') {
      return "E-Participation List";
    } else {
      return tabText;
    }
  }

  getTabTextCal(tabText) {
    if (tabText == 'Kalendar Aktiviti') {
      return "Kalendar E-Penyertaan";
    } else if (tabText == 'Calendar Activity') {
      return "Calendar E-Participation";
    } else {
      return tabText;
    }
  }

  changeDateFormat(dateVal) {
    let res;
    res = this.datePipe.transform(dateVal, 'dd/MM/yyyy h:mm a')

    return res;
  }

  formatDate(dateStr) {
    if (!dateStr) {
      return '';
    }
    let strDate = moment(dateStr).format('DD-MM-YYYY').toString();
    let day = strDate.split('-')[0];
    let month = this.convertMonthName(strDate.split('-')[1]);
    let year = strDate.split('-')[2];
    return day+'-'+month+'-'+year;
  }

  setCalendarEvents(activityData) {

    let sDate;
    let eDate;
    let sT;
    let eT;

    this.event = [];
    activityData.forEach(item => {
      sDate = new Date(item.publishDate);
      eDate = new Date(item.endDate);
      sT = this.changeDateFormat(item.publishDate)
      eT = this.changeDateFormat(item.endDate)

      let body = {
        'id': null,
        'title': null,
        'start': null,
        'end': null,
        'startTime': null,
        'endTime': null,
        'allDay' : null,
        'desc': null,
        'location': null,
        'color': null,
        'image': null,
        'agencyName': null,
        'agencyUrl': null,
        'contentCode': null
      };

      body.id = item.contentId;
      body.title = item.contentTitle;
      body.start = sDate;
      body.end = eDate;
      body.startTime = sT;
      body.endTime = eT;
      body.allDay = true,
      body.desc = item.contentText;
      //body.location = item.eventLocation;

      
      body.agencyName = item.agency.agencyName;
      body.agencyUrl = item.agency.agencyWebsiteUrl;
      if (item.agency.agencyImage) {
        body.image = item.agency.agencyImage.mediaFile; 
      }
      body.contentCode = item.contentCode;
      //   body.color = '#7e9e00';
      this.event.push(body);
     
    });
  }

  renderCalendar(calEvent, mediaPath) {

    setTimeout(() => {

      this.options = {
        locale: this.lang,
        editable: false,
        eventLimit: false,
        header: {
          left: 'prev,next today',
          center: 'title',
          right: null
        },
        events: calEvent,
        firstDay: 0,
        eventClick: (events) => {

          /*$('#title').html(events.title);
          $('#start').html(events.startTime);
          $('#end').html(events.endTime);
          $('#desc').html(events.desc);
          $('#agencyName').html(events.agencyName ? events.agencyName : '-');
          $('#organizerUrl').html(events.agencyUrl ? events.agencyUrl : '-');
        
          if (events.image) {
            $("#imageContainer").css('display', 'block');
            $("#eventImage").attr("src", mediaPath + events.image);
          } else {
            $("#imageContainer").css('display', 'none');
          }

          $('#details').css('display', 'block');
          $('.overlay').css('display', 'block'); */
          this.router.navigate(['content', events.contentCode], { queryParams: this.myflag });
        },
        eventAfterAllRender: (view)=> {
        
          if (this.selected != this.chgSelected) {
            this.loading = true;
            setTimeout(()=> {
              this.selected = this.chgSelected;
              this.loading = false;
            }, 100);
          }
        },
        /*eventMouseover: function (events, domEvent) {
          //$('.fc-event').attr('title', events.title);
          var layer =	"<div id='events-layer' class='fc-transparent' style='position:absolute; width:100%; height:100%; top:-1px; text-align:right; z-index:100; color: black'>Test</div>";
	        $(this).append(layer);
        },

        eventMouseout: function(events, domEvent) {
          $(this).find('div[id*=events-layer]').remove();
        }, */
        
        buttonText: {
          today: this.translate.instant('calendar.view.today')
        },
        timeFormat: 'hh:mm a'

      };

      $('#calendar').fullCalendar('destroy');
      $('#calendar').fullCalendar(this.options);
     
    }, 500);
   
    return this.options;
  }

 

  ngOnInit() {
    if(!this.langId){
      if (localStorage.getItem('languageId')) {
        this.langId = localStorage.getItem('langID');
      } else {
        this.langId = 1;
      }
    }
    this.articleData = this.articleService.getArticle();
    this.moduleName = this.router.url.split('/')[1];
    this.topicID = parseInt(this.router.url.split('/')[2]);

    setTimeout(()=>{
      this.articleLoaded = true;
    },400)

  }

  ngAfterViewInit() {
  
    setTimeout(() => {
      this.sharedService.sentToGtag();
    }, 1000); 

    setTimeout(() => {
      this.initImagePopup();
    }, 1500);
    
    this.sharedService.loadFontSizeData();
    this.menuLink = 'hotlink';   

    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();
  }

  catSelectedChange(event?) {
    
    //console.log(this.currEPartCatCode);
    let activityData = this.articleService.articles.filter((article) => {
      return article.contentList[0];
    });

    //alert(activityData[0].template);
    if (activityData[0] && activityData[0].template !== 'eparticipation') {
      return;
    }

    if (activityData[0] && activityData[0].contentList) {
      //console.log(activityData[0].contentList);
      let calendarData = activityData[0].contentList.filter((list) => {
        return list.tab == 'Kalendar Aktiviti' || list.tab == 'Calendar Activity';
      });

      //console.log(calendarData);

      if (this.currEPartCatCode || this.currEPartCatCode != 0) {
        /*let flrActivityData = calendarData[0].contents.filter((list) => {
          return list.categoryCode == this.currEPartCatCode;
        }); */
        let flrActivityDataOpen = calendarData[0].contents.filter((list) => {
          if (list.categoryCode == this.currEPartCatCode && (list.status == 'Buka' || list.status == 'Open')) {
            return list;
          }
       

        });
        let flrActivityDataClose = calendarData[0].contents.filter((list) => {
          if (list.categoryCode == this.currEPartCatCode && (list.status == 'Tutup' || list.status == 'Close')) {
            return list;
         }
        });

        let flrActivityDataOpenSort = flrActivityDataOpen.sort((a,b) => { return b["publishDate"] - a["publishDate"]});
        let flrActivityDataCloseSort = flrActivityDataClose.sort((a,b) => { return b["endDate"] - a["endDate"]});

        //let flrActivityData = flrActivityDataOpen.concat(flrActivityDataClose);
        let flrActivityData = flrActivityDataOpenSort.concat(flrActivityDataCloseSort);
        this.selectedActList = flrActivityData;
        console.log(this.selectedActList);
      } else if (!this.currEPartCatCode || this.currEPartCatCode == 0) {
        let flrActivityDataOpen = calendarData[0].contents.filter((list) => {
          if (list.status == 'Buka' || list.status == 'Open') {
            return list;
          }
        });
        let flrActivityDataClose = calendarData[0].contents.filter((list) => {
          if (list.status == 'Tutup' || list.status == 'Close') {
            return list;
         }
        });

        let flrActivityDataOpenSort = flrActivityDataOpen.sort((a,b) => { return b["publishDate"] - a["publishDate"]});
        let flrActivityDataCloseSort = flrActivityDataClose.sort((a,b) => { return b["endDate"] - a["endDate"]});

        //let flrActivityData = flrActivityDataOpen.concat(flrActivityDataClose);
        let flrActivityData = flrActivityDataOpenSort.concat(flrActivityDataCloseSort);
        this.selectedActList = flrActivityData;
        console.log(this.selectedActList);
      }
    }

  }

  catSelectedArchChange(event?) {
    //console.log(this.currEPartCatCode);
    let activityData = this.articleService.articles.filter((article) => {
      return article.contentList[0];
    });

    //alert(activityData[0].template);
    if (activityData[0] && activityData[0].template !== 'eparticipation') {
      return;
    }

    if (activityData[0] && activityData[0].contentList) {
      //console.log(activityData[0].contentList);
      let calendarData = activityData[0].contentList.filter((list) => {
        return list.tab == 'Archive' || list.tab == 'Arkib';
      });

      //console.log(calendarData);

      if (this.currArchCatCode || this.currArchCatCode != 0) {
        let flrActivityData = calendarData[0].contents.filter((list) => {
          return list.categoryCode == this.currArchCatCode;
        });
        this.selectedArchList = flrActivityData;
        console.log(this.selectedArchList);
      } else if (!this.currArchCatCode || this.currArchCatCode == 0) {
        let flrActivityData = calendarData[0].contents.filter((list) => {
          return list;
        });
        this.selectedArchList = flrActivityData;
        console.log(this.selectedArchList);
      }

      
    }

  }


  getEpartCategoryList(lang) {
    console.log('langId:'+lang);
    this.loading = true;
    this.navService.getEpartCategory(lang).subscribe(data => {
      let cat = {
        "categoryId": 53832,
        "categoryName": this.translate.instant('home.epartall'),
        "categoryCode": 0,
        "categorySort": 0,
        "isActiveFlag": true,
        "template": "eparticipation"
        }
      this.ePartCatList = [];
      if (data["statusCode"] == "SUCCESS") {
        this.ePartCatList = data.list;
        this.ePartCatList.unshift(cat);
        this.currEPartCatCode = 0;
        this.currArchCatCode = 0;
      }
      this.loading = false;
    });
  }

  showImgPopup() {
    this.showImageBox = 'block';
   }

   hideImgPopup() {
   this.showImageBox = 'none';
  }

  initImagePopup() {
    this.imageNode = this.imageRef.nativeElement.querySelector('#popImage');
    //console.log(this.imageNode);
    if (this.imageNode) {
      this.imageNode.addEventListener('click', this.onClick.bind(this));
    }
    //document.getElementById('popImage').addEventListener("click",function() {alert('test')});   
  }

  onClick(event){
    console.log(event);
    let url = this.imageNode.src;
    console.log(url);
    this.imageRef.nativeElement.querySelector('#imageTag').src = url;
    //this.sharedService.showSuccess(url,'');
    this.showImgPopup();
  }

  toUnsafe(safeText) {
    return safeText.replace(/\&/g, "*;");
  }

  formatSafeText(safeText) {
    return safeText.replace(/\*;/g, "&");
  }

  ngDoCheck() {
    if (this.scrollpanel) {
      if (this.scrollpanel.nativeElement.scrollWidth > this.scrollpanel.nativeElement.clientWidth) {
        this.showLeftRightButton = true;
      } 
    }
   
  }
  ngOnDestroy() {
    console.log('category: destroy');
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
    this.subsriptionArticle.unsubscribe();
  }

  onPreviousSearchPosition(): void {
    this.scrollpanel.nativeElement.scrollLeft -= 120;
  }

  onNextSearchPosition(): void {
    this.scrollpanel.nativeElement.scrollLeft += 120;
  }

  getThemeName() {
    document.documentElement.style.setProperty('--progressbar-background', localStorage.getItem('themeColor'));
    return localStorage.getItem('themeName');
  }


  getAlbum(tabId) {
   debugger;
    // API calls...
  }

  getTheme() {
    return localStorage.getItem('themeColor');
  }

  clickTopMenu(e){
    this.router.navigate(['/category', e.categoryCode], { queryParams: this.myflag });
   
    event.preventDefault();
  }

  clickSideMenu(e, status, event) {
    this.navService.loader = true;
    this.statusID = status;
    // this.navService.getSubArticleUrl(e.categoryCode, localStorage.getItem('langID'));
    // this.navService.triggerSubArticle(e.categoryCode, localStorage.getItem('langID'));
    this.router.navigate(['/subcategory', e.categoryCode], { queryParams: this.myflag });
   
   
    event.preventDefault();
  }

  clickSideMenuByAgency(e, status, event) {
    this.navService.loader = true;
    this.navService.getSubArticleUrlByAgency(localStorage.getItem('langID'));
    this.navService.triggerSubArticleAgency(localStorage.getItem('langID'));
    this.router.navigate(['/subcategory', 'agency'], { queryParams: this.myflag });
   
    
    event.preventDefault();
  }

  clickContentFromMenu(pId, aId, status, event) {
    this.navService.loader = true;
    this.statusID = status;
    // this.navService.triggerContent(aId, localStorage.getItem('langID'));
    // this.navService.getContentUrl(aId, localStorage.getItem('langID'));
    this.router.navigate(['/content', aId], { queryParams: this.myflag });
   
    event.preventDefault();
  }

  getModule(data){
    let a = data.split("/");
    return a[1];
  }

  getID(data){
    let a = data.split("/");
    return a[2];
  }

  getJson(x, p){
    let z = x.replace('[', '').replace(']', '');
    let y = z.split(',');
    return y[p]
  }

  appTracking(refCode){
    this.loading = true;
    const readUrl = `${this.config.urlPortal}agencyapplication/tracking?refCode=${refCode}&source=life-event`;
    const req = this.http.post(readUrl,'')
      .subscribe(
        res => {
          this.loading = false;
        },
        err => {
          console.log("Error occured");
          this.loading = false;
        }
      );
  }

  // triggerArticle(moduleName, lang, topicID) {
  //   this.loading = true;
  //   this.route.paramMap
  //     .switchMap((params: ParamMap) =>
  //       this.navService.getArticleData(moduleName, lang, topicID))
  //     .subscribe(resSliderData => {
  //       this.articles = resSliderData;
  //       this.breadcrumb = this.breadcrumbService.getBreadcrumb();
  //       this.isValid = this.breadcrumbService.isValid = true;
  //       this.breadcrumb = this.breadcrumb.name = '';
  //       this.loading = false;
  //     });
  // }

  checkImgData(e) {
    if (e) {
      const chkData = e.search('<img');
      if (chkData != -1) {
        return true;
      } else {
        return false;
      }
    }

  }

  convertMonthName(objName:String) {

    let objElem;

    if(this.langId == 2) {

      switch (objName) {

        case "01":
          objElem = "Jan"
          break;

        case "02":
          objElem = "Feb"
          break;

        case "03":
          objElem = "Mac"
          break;

        case "04":
          objElem = "Apr"
          break;

        case "05":
          objElem = "Mei"
          break;

        case "06":
          objElem = "Jun"
          break;

        case "07":
          objElem = "Jul"
          break;

        case "08":
          objElem = "Ogs"
          break;

        case "09":
          objElem = "Sep"
          break;

        case "10":
          objElem = "Okt"
          break;

        case "11":
          objElem = "Nov"
          break;

        case "12":
          objElem = "Dis"
          break;

        }
    } else if(this.langId == 1) {
      
      switch (objName) {

        case "01":
          objElem = "Jan"
          break;

        case "02":
          objElem = "Feb"
          break;

        case "03":
          objElem = "Mar"
          break;

        case "04":
          objElem = "Apr"
          break;

        case "05":
          objElem = "May"
          break;

        case "06":
          objElem = "Jun"
          break;

        case "07":
          objElem = "Jul"
          break;

        case "08":
          objElem = "Aug"
          break;

        case "09":
          objElem = "Sep"
          break;

        case "10":
          objElem = "Oct"
          break;

        case "11":
          objElem = "Nov"
          break;

        case "12":
          objElem = "Dec"
          break;

        }
      }
      
    return objElem;
  }



}



// WEBPACK FOOTER //
// ./src/app/article/article.component.ts